// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\locations\\\\PlanYourVisitSection\\\\components\\\\PhoneIcon.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\locations\\PlanYourVisitSection\\components\\PhoneIcon.tsx");
  import.meta.hot.lastModified = "1757171103328.2522";
}
// REMIX HMR END

export function PhoneIcon() {
  return <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.6484 11.5469L19.0234 13.4219C19.7266 13.6953 20.1172 14.4375 19.9609 15.1797L19.0234 19.5547C18.8672 20.2578 18.2031 20.8047 17.5 20.8047C17.2266 20.8047 16.9922 20.7656 16.7578 20.7656C16.3672 20.7656 15.9766 20.7266 15.625 20.6875C6.83594 19.75 0 12.3281 0 3.26562C0 2.5625 0.507812 1.89844 1.21094 1.74219L5.58594 0.804688C6.32812 0.648438 7.07031 1.03906 7.34375 1.74219L9.21875 6.11719C9.49219 6.74219 9.33594 7.48438 8.78906 7.91406L7.1875 9.24219C8.24219 11.0391 9.72656 12.5234 11.5234 13.5781L12.8516 11.9766C13.2812 11.4297 14.0234 11.2734 14.6484 11.5469ZM17.2266 18.8906L18.0469 15.0234L14.1406 13.3438L13.0078 14.75C12.4219 15.4531 11.4062 15.6484 10.5859 15.1797C8.51562 13.9688 6.79688 12.25 5.58594 10.1797C5.11719 9.35938 5.3125 8.34375 6.01562 7.75781L7.42188 6.625L5.74219 2.71875L1.875 3.53906C1.99219 11.9766 8.78906 18.7734 17.2266 18.8906Z" fill="#121212" fillOpacity="0.4" />
    </svg>;
}
_c = PhoneIcon;
var _c;
$RefreshReg$(_c, "PhoneIcon");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;